import { encryptData, generateDigitalSignature, generateRandomString } from './utils';

export const buildSecuredHeader = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 23).replace('T', ' ');
    const payload = `${formattedDate}|${generateRandomString(6)}`;
    const encryptedPayload = encryptData(payload);
    const headerValue = `${encryptedPayload.encryptedData};${generateDigitalSignature(encryptedPayload.encryptedData)}`;

    return headerValue;
};
